export default __webpack_public_path__ + "static/media/edit-dark.976724af.svg";